import { PendingTeamJoinCheck } from './PendingTeamJoinCheck';
import { type PendingTeamJoinPorts } from './ports';

/**
 * The check reads the note when it mounts, so it must not mount on a public
 * page or while sign-in is still resolving.
 */
export function PendingTeamJoinGate({ ports }: { ports: PendingTeamJoinPorts }) {
  const { useIsAuthenticated } = ports;
  const { isAuthenticated, isLoading } = useIsAuthenticated();

  if (isLoading || !isAuthenticated) return null;
  return <PendingTeamJoinCheck ports={ports} />;
}
